import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import classes from './QuestionText.module.css'
import useAutosizeTextArea from "../../../hooks/useAutosizeTextArea"
import { calculateScore } from "../../utils";
import correct from '../../../assests/correct.svg';
import inCorrect from '../../../assests/inCorrect.svg';
import { FeedbackTypesEnum } from "../../../models/FeedbackTypesEnum";

const QuestionText = ({
    points,
    longAnswer,
    completed,
    correctAnswers,
    handleChangeAnsData,
    submission,
    statusObject,
    scoreByRetries,
    id,
    feedback,
    ansData,
    sendInProgress,
    index }) => {

    const [value, setValue] = useState('');
    const [valueChanged, setValueChanged] = useState(false);
    const { texts, direction } = useSelector(state => state.translate);
    const iconsObj = useMemo(() => [{ correct: correct, inCorrect: inCorrect }], [])
    const textareaRef = useRef();

    useAutosizeTextArea(textareaRef.current, value);

    useEffect(() => {
        if (valueChanged) {
            const correct = correctAnswers.some(ans => ans === value.trim());
            const correctText = <div>{correctAnswers.map(ans => <div className={classes.CorrectAnsFeedback}>{ans} </div>)} </div>
            handleChangeAnsData({
                id: id,
                correct: correct,
                correctText: correctText,
                solution: value !== "" ? value : null,
                score: calculateScore(correct, submission?.attempts + 1 || 0, statusObject.retryConditions, scoreByRetries, points),
                success: correct ? correct : longAnswer ? null : false
            })
        }
    }, [value]);

    useEffect(() => {
        if(ansData?.solution){
            setValue(ansData.solution)
        }
        else if (submission) {
            setValueChanged(false)
            setValue(submission.solution)
        }
    }, [submission, id, index])

    const handleChange = (e) => {
        setValue(e.target.value)
        setValueChanged(true)
    }

    useEffect(() => {
        if (feedback.show && feedback.type === FeedbackTypesEnum.MaxRetries) {
            setValue(correctAnswers.join(' / '))
        }
    }, [feedback])


    return <div className={`${classes.Question} ${feedback.show && classes[feedback.type]}`}>
        {feedback.show && (feedback.type === 'correct' || feedback.type === 'inCorrect') && <img src={iconsObj[0][feedback.type]} className={classes.Icon} />}
        <div className={classes.QuestionText}>
            {longAnswer ?
                <textarea disabled={completed || sendInProgress} ref={textareaRef} onChange={handleChange} value={value} className={`${classes[direction]} ${classes.LongAnswer}`} placeholder={texts.answer}></textarea> :
                <input disabled={completed || sendInProgress} onChange={handleChange} value={value} className={`${classes.AnsDemo} ${feedback.type === FeedbackTypesEnum.MaxRetries && classes.AfterRetries}`} placeholder={texts.answer} type='text'></input>
            }
            <div className={classes.Pen}></div>
        </div>
    </div>
}
export default QuestionText;